<template>
    <div :id="'item-' + element.id"
         class="item pb-3 mb-5 border-bottom">

        <transition mode="out-in" name="slide">
            <div v-if="!isEdit" class="row">
                <h2 class="header__name col-12 col-md-8">{{ !online ? 'Offline - ' : '' }}{{ element.headline }}</h2>

                <h2 v-if="!isEdit && element.price"
                    class="font-weight-bold text-right col-12 col-md-4">€ {{ element.price }}</h2>

                <p class="col-12"><i class="fad fa-calendar-week"></i> Angebot gültig: {{ startDate }}
                    {{ endDate }} </p>

                <div class="col-12"
                     v-html="element.description"></div>

                <buttons :isLoading="isLoading"
                         @delete="deleteItem(item.id)"
                         @edit="isEdit = true"></buttons>
            </div>

            <buero-form
                v-if="isEdit"
                :elementValues="this.element"
                :schema="schema"
                method="patch"
                url="/api/merchant/offers"
                @cancel="cancelEdit"
                @updateItem="updateItem"></buero-form>
        </transition>
    </div>
</template>

<script>
import {Form} from './Form';

export default {
    name: 'Offer',
    props: {
        item: Object,
    },
    data() {
        return {
            isEdit: false,
            element: this.item,
            elementForm: JSON.parse(JSON.stringify(this.item)),
            errors: {},
            isLoading: false,
            schema: [],
        };
    },

    mounted() {
        this.schema = (new Form('Element bearbeiten')).schema();
    },

    methods: {
        cancelEdit() {
            //reset edit Form on cancel
            this.elementForm = JSON.parse(JSON.stringify(this.item));
            this.isEdit = false;
        },
        updateItem(payload) {
            this.element = payload;
            this.elementForm = payload;
            this.isEdit = false;
        },
        deleteItem(payload) {

            this.$swal({
                title: 'Sind Sie sicher?',
                text: 'Sie können dies nicht rückgängig machen!',
                showDenyButton: true,
                confirmButtonText: `Löschen`,
                denyButtonText: `Nicht löschen`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading = true;
                    axios.delete('/api/merchant/offers/' + payload).then((response) => {
                        this.$swal({
                            title: response.data.message,
                        });
                        this.isLoading = false;
                        this.$emit('deleteItem', payload);
                    }).catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten',
                        });
                        this.isLoading = false;
                    });
                }
            });
        },
    },

    computed: {

        startDate() {
            return moment(this.element.date_from).format('LL');
        },
        endDate() {
            if (this.element.date_to) {
                return ' bis ' + moment(this.element.date_to).format('LL');
            }
        },

        online() {
            let tmpDate = moment().format('YYYY-MM-DD');
            return moment(tmpDate).isBetween(this.element.date_from, this.element.date_to, null, '[]');
        },
    },
};
</script>
